export const GUIDES_CONTENT = [
    {
        title: "🌱 Introduction to Pawsible",
        coreConcepts: [
          {
            title: "Our Mission & Brand Promise",
            detailKey: "missionBrandPromise"
          },
          {
            title: "Emotional Connection & Storytelling in Pet Care",
            detailKey: "emotionalStorytelling"
          },
          {
            title: "The “Home Away from Home” Experience",
            detailKey: "homeAwayExperience"
          },
          {
            title: "Orientation & Tour SOP",
            detailKey: "orientationTour"
          },
          {
            title: "Policies, Pay, & Scheduling",
            detailKey: "policiesPayScheduling"
          },
          {
            title: "Training Path & Certification",
            detailKey: "trainingPathway"
          }
        ]
    },
    {
      title: "🐶 Dog - Canine Fundamentals",
      coreConcepts: [
        {
          title: "Developmental Stages of Dogs",
          detailKey: "dogDevelopmentStages"
        },
        {
          title: "Understanding Canine Behavior",
          detailKey: "canineBehavior"
        },
        {
          title: "Learning Theory in Practice",
          detailKey: "learningTheory"
        },
        {
          title: "Safe Handling Techniques",
          detailKey: "safeHandling"
        },
        {
          title: "Obedience Training & Cue Introduction",
          detailKey: "obedienceCueIntro"
        },
        {
          title: "Reinforcement & Behavior Shaping",
          detailKey: "behaviorShaping"
        },
        {
          title: "Behavioral Challenges & Redirection",
          detailKey: "behavioralChallenges"
        },
        {
          title: "Safety Protocols & Environment Setup",
          detailKey: "safetyEnvironment"
        },
        {
            title: "Canine Emergency Response Protocols",
            detailKey: "dogEmergencies"
        }          
      ]
    },
    {
      title: "🐱 Cat - Feline Fundamentals",
      coreConcepts: [
        {
            title: "Understanding Cat Temperaments",
            detailKey: "catTemperaments"
          },
          {
            title: "Basic Health & Safety for Cats",
            detailKey: "catHealthSafety"
          },
          {
            title: "Reading Cat Body Language",
            detailKey: "catBodyLanguage"
          },
          {
            title: "Feline Socialization & Handling",
            detailKey: "catSocialization"
          },
          {
            title: "Feline Emergency Response Protocols",
            detailKey: "catEmergencies"
          }
      ]
    },
    {
        title: "💬 Communication & Service",
        coreConcepts: [
          {
            title: "Public Speaking & Etiquette",
            detailKey: "publicSpeakingEtiquette"
          },
          {
            title: "Communicating With Empathy & Clarity",
            detailKey: "empathyClarity"
          },
          {
            title: "Handling Difficult Situations With Pet Parents",
            detailKey: "handlingDifficultClients"
          },
          {
            title: "Creating WOW Moments at Drop-off & Pick-up",
            detailKey: "wowMoments"
          },
          {
            title: "How to Give and Receive Peer Feedback",
            detailKey: "peerFeedback"
          },
          {
            title: "Team Huddles: Daily Communication Flow",
            detailKey: "teamHuddleProtocol"
          },
          {
            title: "Conflict Resolution Between Staff Members",
            detailKey: "internalConflictResolution"
          }
        ]
    },
    {
        title: "🧠 Professionalism & Staff Growth",
        coreConcepts: [
            {
                title: "Pawsible Culture: Ethics, Inclusion & Energy",
                detailKey: "ethicsAndCulture"
            },
            {
                title: "Upselling With Confidence",
                detailKey: "upsellingWithConfidence"
            },
            {
                title: "Hosting Events & Representing the Brand",
                detailKey: "brandAmbassadorSkills"
            },
            {
                title: "Safe Feeding & Food Handling Practices",
                detailKey: "foodHandlingAndFeeding"
            },
            {
                title: "Mentorship & Buddy Program",
                detailKey: "mentorshipProgram"
            },
            {
                title: "Career Growth & Promotion Criteria",
                detailKey: "careerPathway"
            }
        ]
    }
  ];